export const NOTIFICATIONS_DRAWER_KEY = Symbol("notifications-drawer");
